import React from 'react';
import { Loader } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent } from './ui/dialog';

interface ImportLoadingModalProps {
  open: boolean;
}

const ImportLoadingModal: React.FC<ImportLoadingModalProps> = ({ open }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open}>
      <DialogContent className="sm:max-w-sm">
        <div className="flex flex-col items-center py-8">
          <Loader className="h-12 w-12 animate-spin text-primary mb-4" />
          <h3 className="text-lg font-semibold mb-2">
            {t('import.loading.title')}
          </h3>
          <p className="text-sm text-muted-foreground text-center">
            {t('import.loading.description')}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ImportLoadingModal;
